module.exports = __webpack_public_path__ + "static/media/sreemongol.ae829b80.jpg";